import { WidgetRuntime } from '../runtime'
import { Event } from './event'
import { EventContext } from './event-context'

export function track(runtime: WidgetRuntime) {
  return (events: Event[], ctx: EventContext) => {
    for (const e of events) {
      runtime.args.runCallbacks(e.type, e.widget ? e.widget.id : undefined, e.prettyData(), ctx)
    }
  }
}
